/**
 * Helper function for updating the current URL search parameters. Also sends a page view event to segment.
 * @param {Record<string, string>} [params] The query parameters to set, as a key-value object. If omitted, existing
 * query parameters will be removed.
 */
export function updateSearchParams(params) {
  history.pushState(params, '', params ? `?${new URLSearchParams(params)}` : window.location.pathname)

  // Send a page view event to segment if the user has accepted the OneTrust targeting cookies category
  if (window.OnetrustActiveGroups?.includes('C0004')) {
    window.analytics?.page?.('megaport', document.title, { category: 'megaport' })
  }
}
